import React, { useCallback, useState } from "react";
import { FloatingDivProps } from "../FloatingDiv/FloatingDiv";
import { useIsRefClicked } from "../../helperfunctions/useIsRefClicked";
import { IconNames, LucideIcon } from "../../icon/LucideIcon";

export interface DropdownNestedChildren {
  parent: FloatingDivProps["triggerComponent"] | React.ReactElement;
  children?: DropdownNestedChildren[];
}

interface NestedDropdownProps {
  label?: string;
  icon?: IconNames;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const NestedDropdown = ({
  label = "More",
  icon,
  disabled = false,
  onClick,
  children,
  style,
}: NestedDropdownProps) => {
  const [show, setShow] = useState<boolean>(false);
  const onClickOutside = useCallback(() => {
    setShow(false);
  }, []);
  const { ref } = useIsRefClicked<HTMLLIElement>({ onClickOutside });
  return (
    <li className="dropdown-submenu" ref={ref}>
      <button
        className={`btn btn-sm  btn-ghost-secondary flex align-center gap-5 dropdown-submenu-trigger`}
        style={{
          ...(show && { backgroundColor: "var(--gray-200)" }),
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShow((prevState) => !prevState);
          onClick?.(e);
        }}
        disabled={disabled}
      >
        {icon && <LucideIcon name={icon} style={{ pointerEvents: "none" }} />}
        {label}
        <LucideIcon
          name={show ? "chevron-down" : "chevron-right"}
          style={{ pointerEvents: "none", marginLeft: "auto" }}
        />
      </button>
      <ul className={`dropdown-menu`} style={{ display: show ? "block" : "none", height: "fit-content", ...style }}>
        {children}
      </ul>
    </li>
  );
};
